import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginWithEmailPassword, clearToken } from "../api/auth";
import { decodeJwtPayload } from "../utils/jwt";

const AuthContext = createContext(null);

export default function AuthProvider({ children }) {
  const [token, setToken] = useState(() => sessionStorage.getItem("access_token") || "");
  const [user, setUser] = useState(null);
  const [authReady, setAuthReady] = useState(false);
  const navigate = useNavigate();

  const logOut = () => {
    setUser(null);
    setToken("");
    clearToken();
    navigate("/login");
  };

const loginAction = async ({ email, password }) => {
  try {
    const jwt = await loginWithEmailPassword(email, password);
    setToken(jwt);

    const claims = decodeJwtPayload(jwt);
    const mail =
      claims?.["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"] || email;

    setUser(mail);
    navigate("/");
    return jwt;
  } catch (e) {
    
    console.error(e);
    throw e;
  }
};


  useEffect(() => {
    const verify = async () => {
      if (!token) {
        setAuthReady(true);
        return;
      }
      try {
        const claims = decodeJwtPayload(token);
        const mail =
          claims?.["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
        if (!mail) {
          logOut();
          return;
        }
       
        setUser(mail);
      } catch {
        logOut();
      } finally {
        setAuthReady(true);
      }
    };
    verify();
  }, [token]);

  return (
    <AuthContext.Provider value={{ token, user, authReady, loginAction, logOut }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
